import React from 'react';
import { withStyles } from '@material-ui/core'
import { Field } from 'formik'
import { Select } from 'formik-material-ui'
import { Box, MenuItem, ListSubheader, FormHelperText } from '@material-ui/core'

const StyledSelect = withStyles((theme) => ({
  root: {
    '& input': {
      fontSize: 16,
    },
    '& input::placeholder': {
      textAlign: 'left',
      fontStyle: 'italic',
    },
  },
}))(Select)

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
    },
    '&:hover': {
      backgroundColor: '#63c4ff',
    },
    '&.Mui-selected': {
      backgroundColor: '#53b4ef',
      color: '#003d63',
      fontWeight: 900,
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#43a4df',
    },
  },
}))(MenuItem)

export default function CustomSelect({
  size = 'contained',
  margin = 'dense',
  variant = 'outlined',
  items = [],
  placeholder,
  error,
  ...props
}) {
  return (
    <Box style={{ marginTop: 8, marginBottom: 4, position: 'relative' }}>
      <Field
        component={StyledSelect}
        size={size}
        margin={margin}
        variant={variant}
        fullWidth
        displayEmpty={true}
        renderValue={(value) => {
          const item = items.find(i => i.key === value);
          return item && item.name || <i style={{ color: '#333' }}>{placeholder}</i>;
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
        {...props}
      >
        {items.reduce((acc, item) => {
          if (item.topics) {
            return [
              ...acc,
              <ListSubheader key={item.key}>{item.name}</ListSubheader>,
              ...item.topics.map((topic) => (
                <StyledMenuItem key={topic.key} value={topic.key}>
                  {topic.id === 0 ? <b>{topic.name}</b> : topic.name}
                </StyledMenuItem>
              )),
            ]
          }
          return [
            ...acc,
            <StyledMenuItem key={item.key} value={item.key}>
              {item.id === 0 ? <b>{item.name}</b> : item.name}
            </StyledMenuItem>,
          ]
        }, [])}
      </Field>
      <FormHelperText error={true} style={{ marginLeft: 14, marginTop: 8 }}>
        {error}
      </FormHelperText>
    </Box>
  )
}
